import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@auth';
import { Providers, ProviderTuple } from '@/shared/providers/Providers';
import { AppIntlProvider } from '@/app/providers/AppIntlProvider';
import { TooltipProvider } from '@/shared/components/Tooltip';
import { Toaster } from 'react-hot-toast';
import App from '@/app/App';
import { setupSentry } from '@/shared/sentry';
import { initializeCtaTracking } from '@/shared/analytics/ctaTracking';
import { captureAttribution } from '@/shared/analytics/attribution';
import { rememberAdClicks } from '@/shared/analytics/adClicks';

setupSentry();
initializeCtaTracking();
captureAttribution(window.location.search);
rememberAdClicks(new URL(window.location.href));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 1,
    },
  },
});

const providers: ProviderTuple[] = [
  [QueryClientProvider, { client: queryClient }],
  [AuthProvider],
  [AppIntlProvider],
  [TooltipProvider],
  [BrowserRouter],
];

const rootElement = document.querySelector('#root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <Providers providers={providers}>
      <App />
      <Toaster position="bottom-right" />
    </Providers>
  );
}
